import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ExternalPortal } from './external-portal-context';
import { PortalPersonaService } from './portal-persona.service';

export const portalReadyGuard: CanActivateFn = () => accessResult();

export function portalPersonaGuard(portal: ExternalPortal): CanActivateFn {
  return () => accessResult(portal);
}

function accessResult(portal?: ExternalPortal) {
  const persona = inject(PortalPersonaService);
  const router = inject(Router);
  return toObservable(persona.state).pipe(
    filter((state) => state.kind !== 'loading'),
    take(1),
    map((state) => {
      if (state.kind !== 'ready') return router.createUrlTree(['/portal-access']);
      if (portal) return state.portals.includes(portal) ? true : router.createUrlTree(['/portal-access']);
      if (environment.reviewMode) return true;
      return router.createUrlTree([`/${state.portals[0]}`]);
    }),
  );
}
